// ----------------------------------------------------------------------

export default function ToggleButton() {
  return {
    MuiToggleButtonGroup: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
        sizeSmall: {
          fontWeight: 600,
          fontSize: '0.65rem',
          padding: '2px 8px',
          '& .MuiSvgIcon-root': {
            fontSize: '1.1rem',
          },
        },
      },
    },
  };
}
